import React, { useState } from "react";
//import ArrestSearch from "../../components/tools/codis/_codisSearch";
import SearchResults from "../../components/tools/openCaseIncident/_searchResultsOpenCaseIncident";
import OpenCaseIncidentSearch from "../../components/tools/openCaseIncident/_openCaseIncidentSearch";
//import { CADRMSInfo } from "../../interfaces/CADRMSInfo.interface";
import { GetDarInfo_Query, PersonInfo, getDarInfoResponse } from "../../interfaces/getDarInfo_interface";
import { RunDarQuery } from "../../services/getDar.service";
import { Account } from "../../interfaces/auth_interface";
import {getUser, isArrestShow} from "../../services/auth.service";

function OpenCaseIncident() {
    let [cadrms, setCADRMS] = useState<any[]>([])
    let [persons, setCodisPersons] = useState<any[]>([])
    let [user, setUser] = useState<Account>(getUser())
    let [noData, setNoData] = useState<boolean>(false)

    const SubmitSearch = async (params: any, dateType: string, andOrType: string, dropDowns: any) => {
        let search_query: GetDarInfo_Query = {
            "QueryType": "7",
            "Dept": user.Dept,
            "EmpID": user.EmpID,
            "DeptORI": user.DeptORI,
            "DateRange": true,
            "DateTypeValue": (dateType === "Entry Date") ? 0 : 1,
            "FromDate": params.fromDate.toLocaleString(),
            "ToDate": params.toDate.toLocaleString(),
            "SearchType": andOrType,
            "IndicatorOn": true,
            "TopArrestNumber": 0,
            "FNames": params.FirstName ? params.FirstName.split(',') : [],
            "MNames": params.MI ? params.MI.split(',') : [],
            "LNames": params.LastName ? params.LastName.split(',') : [],
            "DOBs": params.DOB ? params.DOB.split(',') : [],
            "SEX": [],
            "Address": "",
            "Cities": dropDowns.City ? dropDowns.City : [],
            "States": [],
            "Zip": "",
            "Statutes": dropDowns.Statute ? dropDowns.Statute : [],
            "Gang": [],
            "FBIs": params.FBI ? params.FBI.split(',') : [],
            "SBIs": params.SBI ? params.SBI.split(',') : [],
            "DLNos": params.DL ? params.DL.split(',') : [],
            "PlateNos": params.Plate ? params.Plate.split(',') : [],
            "VINs": [],
            "AgencyArrested": [],
            "PoliceStopDept": [],
            "Indicators": dropDowns.Indicator ? dropDowns.Indicator : [],
            "Latitude": null,
            "Longitude": null,
            "Radius": 0,
            "ResidentCounty": dropDowns.PersonRole ? dropDowns.PersonRole : [],
            "ArrestedCounty": dropDowns.Nibrs ? dropDowns.Nibrs : [],
            "Arrest_Type": [],
            "CaseNumbers": params.CaseNo ? params.CaseNo.split(',') : [],
            "FTSIDs": [],
        }
        let qRes: getDarInfoResponse = await RunDarQuery(search_query)
        let CADRMS:any[] = []
        setCADRMS([])
        
        if(qRes.AnyTable){
            for(var i of qRes.AnyTable)
            {
                if(!CADRMS.some((cad:any) => cad.AgencyCaseNo === i.AgencyCaseNo)){
                    CADRMS.push(i)
                }
            } 
        }

        if (qRes?.AnyTable?.length === 0) {
            setNoData(true)
        }
        else {
            setNoData(false)
        }

        setCADRMS(CADRMS)
        setCodisPersons(qRes.AnyTable)
    }
    return (
        <div id="ToolsOpenCaseIncident">
            {isArrestShow()?
                <>
                    <OpenCaseIncidentSearch SubmitSearch={SubmitSearch} />
                    {!noData ? <SearchResults CADRMSInfo={cadrms} Persons={persons} /> : <div className="font-bold text-lg ml-5">NO Matching Records Found</div>}
                </>
            :<></>}
        </div>
    );
}

export default OpenCaseIncident;
